<template>
  <div :class="`${prefixClass}__month-panel`">
    <!-- date header-->
    <div :class="`${prefixClass}__header`">
      <a :title="getJumpTitle('prev')" :class="`${prefixClass}__cmd ${prefixClass}__cmd--prev`" @click.stop="goPrevYear">
        <i class="aid aid-chevron-left"></i>
      </a>
      <span>
        <a :class="`${prefixClass}__header-label`"
           @click.stop="showYearPicker">{{ drawYear }}</a>
      </span>
      <a :title="getJumpTitle('next')" :class="`${prefixClass}__cmd ${prefixClass}__cmd--next`" @click.stop="goNextYear">
        <i class="aid aid-chevron-right"></i>
      </a>
    </div>
    <!-- date body-->
    <div :class="`${prefixClass}__body`">
      <table class="month-table flipOutY" @click.stop="handleMonthTableClick">
        <tbody>
          <tr v-for="(row, rowIndex) in rowNum" :key="`row${rowIndex}`">
            <td v-for="(col, colIndex) in getColNum(row)" :key="`col${colIndex}`" :class="getClass(row, col, this)"><a :class="disabledClass(row, col, this)" :month="getMonth(row, col)">{{ getMonthLabel(row, col) }}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { hasClass } from '../util.js'
import locale from '../../../mixins/locale'
import {
  PREFIX_DATE_PICK_CLASS,
  CLASS_SELECTED,
  CLASS_DISABLED,
  CLASS_TODAY
} from '../constants'

export default {
  name: 'TMonthTable',
  mixins: [locale],
  props: {
    minSelected: {
      type: Object
    },
    maxSelected: {
      type: Object
    },
    minSelectRange: {
      type: Object
    },
    maxSelectRange: {
      type: Object
    },
    defaultDrawDate: {
      type: Object
    }
  },
  data: function() {
    return {
      prefixClass: PREFIX_DATE_PICK_CLASS,
      rowSize: 4, // one row year num
      drawDate: this.defaultDrawDate,
      drawMonth: this.defaultDrawDate.month() + 1,
      drawYear: this.defaultDrawDate.year(),
      selectedYearMonth: ''
    }
  },
  computed: {
    nowYearMonth() {
      return moment(
        `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
        'YYYY-MM'
      )
    },
    rowNum() {
      return Math.ceil(12 / this.rowSize)
    }
  },
  watch: {
    defaultDrawDate(newValue) {
      this.drawDate = newValue
    },
    drawDate(newValue) {
      this.drawYear = newValue.year()
    },
    minSelected(newVal, oldVal) {
      if (newVal !== null && this.drawYear === newVal.year()) {
        this.updateSelectedMonth(newVal)
      }
    },
    maxSelected(newVal, oldVal) {
      if (newVal !== null && this.drawYear === newVal.year()) {
        this.updateSelectedMonth(newVal)
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    getColNum(row) {
      if (row * this.rowSize <= 12) {
        return this.rowSize
      } else {
        return 12 % ((row - 1) * this.rowSize)
      }
    },
    getClass(row, col, target) {
      let month = this.getMonth(row, col)
      let current = moment(`${this.drawYear}-${month}`, 'YYYY-MM')
      let classes = []
      // 是否选中
      if (current.isSame(this.selectedYearMonth)) {
        classes.push(CLASS_SELECTED)
      }
      // 是否当前月份
      if (this.nowYearMonth.isSame(current)) {
        classes.push(CLASS_TODAY)
      }

      return classes.join(' ')
    },
    disabledClass(row, col) {
      let month = this.getMonth(row, col)
      let current = moment(`${this.drawYear}-${month}`, 'YYYY-MM')
      // disabled
      if (this.minSelectRange && current.isBefore(this.minSelectRange, 'month')) {
        return CLASS_DISABLED
      }
      if (this.maxSelectRange && current.isAfter(this.maxSelectRange, 'month')) {
        return CLASS_DISABLED
      }
    },
    getMonth(row, col) {
      if (row === 1) {
        return row * col
      } else {
        return (row - 1) * this.rowSize + col
      }
    },
    getMonthLabel(row, col) {
      let month = this.getMonth(row, col)
      return this.t(`t.datepicker.months.m${month}`)
    },
    handleMonthTableClick(event) {
      let target = event.target
      if (target.tagName !== 'A') return
      if (hasClass(target, `${PREFIX_DATE_PICK_CLASS}--disabled`)) return
      // 去掉已选择的元素的选定样式
      if (
        target.parentNode.parentNode.parentNode.querySelector(
          'td.' + CLASS_SELECTED
        )
      ) {
        target.parentNode.parentNode.parentNode.querySelector(
          'td.' + CLASS_SELECTED
        ).className = ''
      }
      // 给当前元素添加选中样式
      target.parentNode.className += ' ' + CLASS_SELECTED
      let month = target.getAttribute('month')
      this.selectedYearMonth = moment(`${this.drawYear}-${month}`, 'YYYY-MM')
      this.drawDate.month(month - 1)
      this.$emit('pick', this.drawDate)
    },
    goPrevYear() {
      this.drawYear = this.drawDate.subtract(1, 'y').year()
    },
    goNextYear() {
      this.drawYear = this.drawDate.add(1, 'y').year()
    },
    // 显示年面板
    showYearPicker() {
      this.$emit('changePicker', 'year')
    },
    getJumpTitle(type) {
      return this.t(`t.datepicker.${type}Year`)
    },
    updateSelectedMonth(newDate) {
      let month = newDate.month()
      this.selectedYearMonth = moment(
        `${this.drawYear}-${month + 1}`,
        'YYYY-MM'
      )
    },
    init() {
      if (this.minSelected && moment.isMoment(this.minSelected)) {
        if (this.drawYear === this.minSelected.year()) {
          this.updateSelectedMonth(this.minSelected)
        }
      }
      if (this.maxSelected && moment.isMoment(this.maxSelected)) {
        if (this.drawYear === this.maxSelected.year()) {
          this.updateSelectedMonth(this.maxSelected)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// month-table.vue?3ef0737d